/**
 * The session's behavioral config — hintsEnabled, autoPlay, gameMode. Held here rather than
 * on the game-state store because the server stopped echoing it on every action response
 * (game-server-api decoupling, session-info surface): GameStateDto no longer carries these
 * fields, so consumers that used to read state.hintsEnabled / state.autoPlay / state.gameMode
 * read this module instead.
 *
 * Populated at session creation from the values the client itself just sent
 * (game-start/game-start-session.js#buildSessionParams), refreshed at init/reload from
 * GET /api/games/{id}/session-info (boot.js#init). gameMode is immutable for a session's
 * lifetime, so once set it cannot go stale mid-session; hintsEnabled/autoPlay are settings
 * toggles the server confirms on reload — plus, since game-menu-hint-learning-toggles, a
 * mid-game path: the hints toggle calls setSessionConfig directly for the live effect and
 * fire-and-forget POSTs /api/games/{id}/session-config so the server's copy — and thus the
 * next reload's echo — agrees with the flip. That toggle sits in the profile overlay's Hilfen
 * section since profile-overlay-and-menu-slim (game-start/game-start-profile-sections.js);
 * game-menu.js carries no session-config write anymore.
 */
let config = { hintsEnabled: true, autoPlay: false, gameMode: "SKAT" };

export function getSessionConfig() {
  return config;
}

export function setSessionConfig(next) {
  config = next;
}

export function resetSessionConfig() {
  config = { hintsEnabled: true, autoPlay: false, gameMode: "SKAT" };
}
